import { Box, Button, Typography, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

function EmailOutlinedIcon({ size = 48 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 6h16c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1zM3 7l9 6 9-6"
      />
    </svg>
  );
}

export function SentState({
  email,
  onBack,
}: {
  email: string;
  onBack: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Box data-testid="login-sent-state" sx={{ textAlign: 'center' }}>
      <Box sx={{ color: 'primary.main', mb: 1, display: 'inline-flex' }}>
        <EmailOutlinedIcon size={48} />
      </Box>
      <Typography variant="h5" component="h1" sx={{ fontWeight: 600, mb: 1 }}>
        {t('login.sent.title')}
      </Typography>
      <Alert
        severity="info"
        sx={{ textAlign: 'left', mb: 3 }}
        data-testid="login-sent-message"
      >
        {t('login.sent.lede', { email })}
      </Alert>
      <Button
        variant="text"
        onClick={onBack}
        data-testid="login-sent-back"
        sx={{ textTransform: 'none' }}
      >
        {t('login.sent.back')}
      </Button>
    </Box>
  );
}
